<template>
  <div class="blog-list" id="blogListContainer">
    <div
      class="
        uk-grid-match
        uk-child-width-1-1
        uk-child-width-1-2@s
        uk-child-width-1-3@m
        uk-text-center
        uk-grid-medium
      "
      uk-grid
    >
      <div v-for="blog in this.displayBlogs" :key="blog.slug_name">
        <blog-item :blog="blog" />
      </div>
    </div>
    <div class="page-selector" v-if="this.currentPage">
      <button
        v-for="page in this.totalPages"
        :key="page"
        class="page-btn"
        :class="{ selected: currentPage === page }"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
    </div>
  </div>
</template>
<script>
import BlogItem from "@/components/blogs/BlogItem";
export default {
  name: "BlogList",
  props: ["blogs"],
  components: { BlogItem },
  data() {
    return {
      currentPage: 1,
      displayBlogs: [],
      BLOG_COUNT_PER_PAGE: 12,
    };
  },
  computed: {
    totalPages() {
      if (this.blogs) {
        if (this.blogs.length % this.BLOG_COUNT_PER_PAGE == 0) {
          return Math.floor(this.blogs.length / this.BLOG_COUNT_PER_PAGE);
        } else {
          return Math.floor(this.blogs.length / this.BLOG_COUNT_PER_PAGE) + 1;
        }
      } else {
        return 0;
      }
    },
    isShowNext() {
      return this.currentPage < this.totalPages;
    },
    isShowPreviouts() {
      return this.currentPage > 1;
    },
  },
  methods: {
    goToPage(nextPage) {
      if (!this.blogs || this.blogs.length == 0) {
        return;
      }
      const isNeedScroll = this.currentPage != nextPage;
      if (isNeedScroll) {
        document
          .getElementById("blogsContainer")
          .scrollIntoView({ behavior: "smooth" });
      }
      this.currentPage = nextPage;
      const sliceStart = Math.floor(this.currentPage - 1) * this.BLOG_COUNT_PER_PAGE;
      this.displayBlogs = this.blogs.slice(sliceStart, this.currentPage * this.BLOG_COUNT_PER_PAGE);
      
    },
  },
  mounted() {
    this.goToPage(1);
  },
};
</script>
<style lang="scss" scoped>
.page-selector {
  margin: 100px auto;
  text-align: center;
  .page-btn {
    border-radius: 50%;
    background-color: #003232;
    display: inline-block;
    width: 43px;
    height: 43px;
    margin: 0 3px;
    background-color: #b6d0c0;
    font-size: 24px;
    line-height: 43px;
    text-align: center;
    font-weight: normal;
    color: #fff;
    border: none;
    padding: 0;
    &.selected {
      background-color: #003232;
    }
    @media (min-width: 960px) {
      &:hover {
        background-color: #408282;
      }
    }
  }
}

@media (min-width: 960px) {
  .blog-list {
    padding: 0 95px;
  }
}
</style>